<template>
  <SelectFont
    class="select-font-wrap"
    v-model="localFontFamily"
    @change="$emit('setFontFamily', $event)"
    @hoverChange="$emit('testFontFamily', $event)"
    @triggerTooltip="$emit('triggerTooltipNeedUpdatePlan')"
    v-bind="$attrs"
  />
</template>

<script>
import SelectFont from '@/components-v2/font/select'

export default {
  name: 'SelectFontWrap',
  components: {
    SelectFont,
  },
  props: {
    fontFamily: {
      type: String,
      default: 'Nunito',
    },
  },
  data() {
    return {
      localFontFamily: this.fontFamily,
    }
  },
}
</script>

<style lang="scss" scoped>
.select-font-wrap {
  ::v-deep {
    .custom-select-box {
      min-width: 124px;
      width: auto;

      .dropdown-menu-custom {
        width: max-content;
      }
    }
    .aha-selected-option {
      height: 40px;
      width: 124px;
      display: flex;
      align-items: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      display: block !important;
      border-radius: 8px;
    }
    svg {
      top: 1.25rem;
    }
  }
}
</style>
